import { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";

export default function InstallApp() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", () => setInstalled(true));
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (installed || isStandalone) return null;

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") setInstalled(true);
      setDeferred(null);
    }
  };

  if (isIOS) {
    return (
      <p data-testid="install-ios-hint" className="flex items-center gap-2 text-xs text-slate-500">
        <Share className="h-3.5 w-3.5 text-amber-500" />
        On iPhone: Share → "Add to Home Screen" to install the app
      </p>
    );
  }

  if (!deferred) return null;

  return (
    <button
      data-testid="install-app-btn"
      onClick={install}
      className="flex items-center gap-3 rounded-md border border-amber-500/40 bg-amber-500/10 px-5 py-3 text-left text-amber-500 transition-all duration-200 hover:-translate-y-0.5 hover:bg-amber-500/20"
    >
      <Download className="h-5 w-5" strokeWidth={2.5} />
      <span>
        <span className="block text-[9px] uppercase tracking-wider opacity-70">Free · no store needed</span>
        <span className="block font-display text-base font-bold leading-none">Install the App</span>
      </span>
    </button>
  );
}
